import React from 'react';
import { Calculator, Plus, Minus, Calendar } from 'lucide-react';

/**
 * Компонент выбора типа расчета дат
 */
const CalculationTypeSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6">
      <div className="block text-lg font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center">
        <Calculator className="w-5 h-5 mr-2 text-cyan-500" />
        Что необходимо рассчитать?
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div
          className={`rounded-lg border p-4 cursor-pointer transition-colors
            ${formData.calculationType === 'difference'
              ? 'bg-cyan-50 dark:bg-cyan-900/30 border-cyan-200 dark:border-cyan-800'
              : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          onClick={() => handleInputChange({ target: { name: 'calculationType', value: 'difference' } })}
        >
          <div className="flex items-center mb-2">
            <input
              type="radio"
              name="calculationType"
              id="type-difference"
              value="difference"
              checked={formData.calculationType === 'difference'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <label htmlFor="type-difference" className="ml-2 font-medium text-gray-900 dark:text-white">
              Разница между датами
            </label>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400 pl-6">
            Рассчитать точное количество дней, недель, месяцев и лет между двумя датами
          </p>
        </div>

        <div
          className={`rounded-lg border p-4 cursor-pointer transition-colors
            ${formData.calculationType === 'add'
              ? 'bg-cyan-50 dark:bg-cyan-900/30 border-cyan-200 dark:border-cyan-800'
              : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          onClick={() => handleInputChange({ target: { name: 'calculationType', value: 'add' } })}
        >
          <div className="flex items-center mb-2">
            <input
              type="radio"
              name="calculationType"
              id="type-add"
              value="add"
              checked={formData.calculationType === 'add'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <label htmlFor="type-add" className="ml-2 font-medium text-gray-900 dark:text-white flex items-center">
              Добавить дни <Plus className="w-4 h-4 ml-1 text-green-500" />
            </label>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400 pl-6">
            Рассчитать дату после добавления определенного количества дней к начальной дате
          </p>
        </div>

        <div
          className={`rounded-lg border p-4 cursor-pointer transition-colors
            ${formData.calculationType === 'subtract'
              ? 'bg-cyan-50 dark:bg-cyan-900/30 border-cyan-200 dark:border-cyan-800'
              : 'bg-white dark:bg-gray-800 border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700'
            }`}
          onClick={() => handleInputChange({ target: { name: 'calculationType', value: 'subtract' } })}
        >
          <div className="flex items-center mb-2">
            <input
              type="radio"
              name="calculationType"
              id="type-subtract"
              value="subtract"
              checked={formData.calculationType === 'subtract'}
              onChange={handleInputChange}
              className="form-radio"
            />
            <label htmlFor="type-subtract" className="ml-2 font-medium text-gray-900 dark:text-white flex items-center">
              Вычесть дни <Minus className="w-4 h-4 ml-1 text-red-500" />
            </label>
          </div>
          <p className="text-sm text-gray-600 dark:text-gray-400 pl-6">
            Рассчитать дату после вычитания определенного количества дней из начальной даты
          </p>
        </div>
      </div>
      {errors.calculationType && (
        <p className="mt-1 text-xs text-red-500 dark:text-red-400">
          {errors.calculationType}
        </p>
      )}
    </div>
  );
};

export default CalculationTypeSection;